import { render } from "./VideoPlayer.vue?vue&type=template&id=50bb2582&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"

import "./VideoPlayer.vue?vue&type=style&index=0&id=50bb2582&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bb2582"]])

export default __exports__